// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Navigation from "../../primitives/Navigation.res.js";
import * as LoadingPage from "./LoadingPage.res.js";
import * as LoadingRoutes from "./LoadingRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function LoadingRouter(props) {
  let subUrlPath = props.subUrlPath;
  if (subUrlPath !== 0) {
    if (subUrlPath.tl !== 0) {
      return JsxRuntime.jsx(Navigation.Redirect.make, {
        route: LoadingRoutes.baseRoute(undefined, undefined)
      });
    } else {
      return JsxRuntime.jsx(LoadingPage.make, {
        text: subUrlPath.hd
      });
    }
  } else {
    return JsxRuntime.jsx(LoadingPage.make, {});
  }
}

let make = LoadingRouter;

export {
  make,
}
/* Navigation Not a pure module */
